module.exports = __webpack_public_path__ + "static/media/icons-ic-cold-call-2.1a18749d.svg";